/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ws_Plan_DraftInputs */

const en_ws_plan_draft = /** @type {(inputs: Ws_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const id_ws_plan_draft = /** @type {(inputs: Ws_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Ws_Plan_DraftInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_plan_draft = /** @type {((inputs?: Ws_Plan_DraftInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Plan_DraftInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_plan_draft(inputs)
	return en_ws_plan_draft(inputs)
});